import { render, staticRenderFns } from "./dispatcher-list.vue?vue&type=template&id=3d870975"
import script from "./dispatcher-list.vue?vue&type=script&lang=js"
export * from "./dispatcher-list.vue?vue&type=script&lang=js"
import style0 from "./dispatcher-list.vue?vue&type=style&index=0&id=3d870975&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports